// Autogenerated file
export const regionTypesEnum = {
    Country: "Country",
    FederalDistrict: "FederalDistrict",
    FederalSubject: "FederalSubject",
    City: "City",
    Town: "Town",
    Village: "Village",
};
export const regionTypes = [
    { label: "Страна", value: "Country" },
    { label: "Федеральный округ", value: "FederalDistrict" },
    { label: "Субъект федерации", value: "FederalSubject" },
    { label: "Крупный город", value: "City" },
    { label: "Город", value: "Town" },
    { label: "Деревня", value: "Village" },
];
